import Api from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';

class PinService {
  constructor(iamIdentityApiUrl, getCustomAccessToken) {
    this.pinApi = new Api(iamIdentityApiUrl);
    if (typeof getCustomAccessToken === "function") {
      this.pinApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.pinApi.addInterceptor(accessTokenInterceptor);
    }
  }
  async initPinSetup(params) {
    const { data } = await this.pinApi.post("/v1/pin/setup", params);
    return data;
  }
  async confirmAndSavePin(params) {
    const { data } = await this.pinApi.post("/v1/pin/confirm", params);
    return data;
  }
  async verifyPin(params) {
    const { data } = await this.pinApi.post("/v1/pin/verify", params);
    return data;
  }
}

export { PinService };
